export default __webpack_public_path__ + "static/media/ig-streetwear.1b53b84e.png";